import {
  Button,
  IconButton,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { DisplayDateTime } from "components/DisplayDate";

const DiscussionTab = ({
  commentsList,
  commentText,
  setCommentText,
  showMentionDropdown,
  filteredUsers,
  selectedMentionIndex,
  handleCommentTextChange,
  handleCommentKeyDown,
  handleMentionSelect,
  handleCommentSubmit,
  renderTextWithMentions,
  deleteComment,
  userDetail,
  data,
  chatContainerRef,
}) => {
  return (
    <div className="flex flex-col h-full">
      <div
        className="flex-1 overflow-y-auto p-4 bg-app-surface-muted min-h-[400px] max-h-[600px]"
        ref={chatContainerRef}
      >
        {commentsList?.length > 0 ? (
          <div className="space-y-3">
            {commentsList.map((comment) => (
              <div key={comment?.id} className="mb-3">
                {userDetail?.email === comment?.commentedBy ? (
                  <div className="text-right">
                    <p className="text-xs text-app-text-secondary mb-1">
                      {comment?.postedBy || comment?.commentedBy}{" "}
                      <DisplayDateTime value={comment?.date} fallback="" />
                    </p>
                    <div className="flex items-center justify-end gap-2">
                      {userDetail?.type === "SUPER_ADMIN" && (
                        <Tooltip title="Delete this comment">
                          <IconButton
                            size="small"
                            onClick={() => deleteComment(comment?.id)}
                            sx={{ padding: "4px" }}
                          >
                            <DeleteIcon sx={{ color: "grey", fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                      <div className="bg-blue-500 text-white rounded-lg py-2 px-3 inline-block max-w-[80%]">
                        <div className="text-sm">
                          {renderTextWithMentions(comment?.text) || comment?.text}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p className="text-xs text-app-text-secondary mb-1">
                      {comment?.postedBy || comment?.commentedBy}{" "}
                      <DisplayDateTime value={comment?.date} fallback="" />
                    </p>
                    <div className="bg-app-surface-hover text-app-text rounded-lg py-2 px-3 inline-block max-w-[80%]">
                      <div className="text-sm">
                        {renderTextWithMentions(comment?.text) || comment?.text}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-app-text-secondary py-8">
            No discussions yet. Start a conversation!
          </div>
        )}
      </div>

      {data?.id && (
        <form
          // onSubmit={handleCommentSubmit}
          className="border-t border-app-border p-3 bg-app-surface relative"
        >
          <div className="relative">
            <textarea
              rows="2"
              className="w-full px-3 py-2 text-sm text-app-text border border-app-border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Write a note... Type @ to mention users"
              value={commentText}
              onChange={handleCommentTextChange}
              onKeyDown={handleCommentKeyDown}
            />

            {showMentionDropdown && filteredUsers.length > 0 && (
              <Paper
                className="absolute bottom-full left-0 right-0 mb-2 max-h-48 overflow-y-auto z-50 shadow-lg"
                elevation={3}
              >
                <List dense>
                  {filteredUsers.map((user, index) => (
                    <ListItem
                      key={user.id}
                      onClick={() => handleMentionSelect(user)}
                      className={`hover:bg-app-surface-hover cursor-pointer ${
                        index === selectedMentionIndex ? "bg-blue-50" : ""
                      }`}
                    >
                      <ListItemAvatar>
                        <Avatar sx={{ width: 32, height: 32 }}>
                          {user.name?.charAt(0)?.toUpperCase()}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={user.name}
                        secondary={user.email}
                        primaryTypographyProps={{ fontSize: "0.875rem" }}
                        secondaryTypographyProps={{ fontSize: "0.75rem" }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
          </div>
          <Button
            // type="submit"
            variant="contained"
            size="small"
            disabled={!commentText.trim()}
            className="mt-2"
            sx={{ float: "right" }}
            onClick={handleCommentSubmit}
          >
            Post
          </Button>
        </form>
      )}
      {!data?.id && (
        <div className="border-t border-app-border p-4 bg-app-surface-muted text-center text-app-text-secondary text-sm">
          Save the RPL certificate to start discussions
        </div>
      )}
    </div>
  );
};

export default DiscussionTab;
